import React from 'react';
import { useTranslate } from 'react-admin';
import RecordTitleButton from '~/components/RecordTitleButton';
import { useChangelog } from '~/hooks/useChangelogContext';

const ViewHistoryButton = () => {
  const { isAvailable, openDrawer } = useChangelog();
  const translate = useTranslate();

  if (!isAvailable) {
    return null;
  }

  return (
    <RecordTitleButton label={translate('components.RecordTitle.history')} onClick={openDrawer} />
  );
};

export default ViewHistoryButton;
